module.exports = __webpack_public_path__ + "static/media/defisnap.b1d43a41.svg";